import React from 'react';
import { GAME_TICK_MS } from '../shared/constants';
import { GameState, PlayerId } from '../types';
import Tooltip from '../ui/Tooltip';

type HUDProps = {
  gameState: GameState;
  myPlayerId: PlayerId | null;
  progress: number;
  C: number;
  dashOffset: number;
};

export default function HUD({ gameState, myPlayerId, progress, C, dashOffset }: HUDProps) {
  const me = myPlayerId ? gameState.players.find(p => p.id === myPlayerId) : null;
  const mySystems = gameState.systems.filter(s => s.owner === myPlayerId).length;
  const myFleets = gameState.fleets.filter(f => f.owner === myPlayerId).length;

  return (
    <div className="hud">
      <div className="brand">Pax Imperialis</div>
      {me && (
        <div className="chips">
          <Tooltip content="Your house name"><div className="chip">👑 {me.name}</div></Tooltip>
          <Tooltip content="Credits"><div className="chip">💰 {me.resources.credits}</div></Tooltip>
          <Tooltip content="Influence"><div className="chip">✨ {me.resources.influence}</div></Tooltip>
          <Tooltip content="Worlds you control"><div className="chip">🌌 {mySystems} worlds</div></Tooltip>
          <Tooltip content="Your fleets"><div className="chip">🚀 {myFleets} fleets</div></Tooltip>
        </div>
      )}
      <Tooltip content={`Tick ${(progress * 100).toFixed(0)}% • ${Math.round(GAME_TICK_MS / 1000)}s`}>
        <div className="tick">
          <svg className="tick-ring" viewBox="0 0 24 24">
            <circle className="bg" cx="12" cy="12" r="10" strokeWidth="3" fill="none" />
            <circle className={`fg ${progress < 0.05 ? 'pulse' : ''}`} cx="12" cy="12" r="10" strokeWidth="3" fill="none" strokeDasharray={C} strokeDashoffset={dashOffset} />
          </svg>
          <span>t{gameState.tick}</span>
        </div>
      </Tooltip>
    </div>
  );
}


